/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SortDirection, SortSelector } from "~/components";
import { SearchSortOrder } from "../types";
import { staticChargeTypeOptions } from "./constants";
import { getChargeTypeLabel } from "./utils";

type Props = {
  sortField: string;
  sortDirection: SearchSortOrder;
  chargeTypes: string[];
  onSortSelect: (value: string) => void;
  onSortOrderChange: (value: SortDirection) => void;
};

export function CloudAccountSort({
  sortField,
  sortDirection,
  chargeTypes,
  onSortSelect,
  onSortOrderChange,
}: Props) {
  const options = [
    ...staticChargeTypeOptions,
    ...chargeTypes.map((chargeType) => ({
      value: chargeType,
      label: getChargeTypeLabel(chargeType),
    })),
  ];

  return (
    <SortSelector
      options={options}
      value={sortField}
      direction={
        sortDirection === SearchSortOrder.Asc
          ? SortDirection.Ascending
          : SortDirection.Descending
      }
      onSelect={(filter) => onSortSelect(filter)}
      onSortChange={onSortOrderChange}
    />
  );
}
